const nl = {
    // Common
    'Close': 'Sluit',
    'From': 'Van',
    'To': 'Naar',
    'Distance': 'Afstand',
    'Estimated time': 'Geschatte tijd',
    'Level': 'Niveau',
    'Search by name, category, building...': 'Zoeken op naam, categorie, gebouw…',
    'Show legend': 'Legende weergeven',
    'Ask with AI': 'Vraag met AI',
    'Nothing was found': 'Er is niets gevonden',
    'd': 'd',
    'h': 'u',
    'min': 'min',
    'Walk': 'Wandelen',
    'Bike': 'Fietsen',
    'Transit': 'Overgang',
    'Drive': 'Rijden',
    'Start wayfinding': 'Begin met navigeren ',
    // Location Details
    'Read full description': 'Lees de volledige beschrijving',
    // Locations List
    'Locations': 'Locaties',
    'Directions not available': 'Routebeschrijving niet beschikbaar',
    'Start directions': 'Start routebeschrijving',
    // Route instructions
    'Previous': 'Vorig',
    'Next': 'Volgende',
    'StepYofX': 'Stap {{activeStep}} van {{totalSteps}}',
    // Route Instructions Step
    'You have arrived': 'Je bent aangekomen',
    'Leave': 'Verlaat',
    'Park': 'Parkeer',
    'at': 'bij',
    'Building': 'Gebouw',
    'Venue': 'Locatie',
    'Take staircase to level': 'Neem de trap naar niveau',
    'Take the ladder to level': 'Neem de ladder naar niveau',
    'Take elevator to level': 'Neem de lift naar niveau',
    'Take escalator to level': 'Neem de roltrap naar niveau',
    'Take wheelchair lift to level': 'Neem de rolstoellift naar niveau ',
    'Take wheelchair ramp to level': 'Neem de rolstoelhelling naar niveau',
    'Exit': 'Verlaat',
    'Enter': 'Binnengaan',
    'stops': 'stopt',
    'and continue': 'en doorgaan',
    'Continue straight ahead': 'Ga rechtdoor',
    'Go left': 'Ga links',
    'Go sharp left': 'Ga scherp naar links',
    'Go slight left': 'Ga lichtjes naar links',
    'Go right': 'Ga rechts',
    'Go sharp right': 'Ga scherp naar rechts',
    'Go slight right': 'Ga lichtjes naar rechts',
    'Turn around': 'Draai je om',
    // Wayfinding component
    'Switch': 'Schakelaar',
    'Avoid stairs and escalators': 'Vermijd trappen en roltrappen',
    'Include bus transportation': 'Busvervoer opnemen',
    'No route found': 'Geen route gevonden',
    'My position': 'Mijn positie',
    'Go!': 'Gaan!',
    'Directions': 'Richtingen',
    'Choose departure': 'Kies vertrek',
    'Choose destination': 'Kies bestemming',
    // Venue selector
    'Venues': 'Locaties',
    'Select venue': 'Kies locatie',
    'Current': 'Huidige',
    // QR code dialog
    'Scan QR code': 'QR-code scannen',
    'Scan the QR code to see the route on your phone': 'Scan de QR-code om de route op jouw telefoon te bekijken',
    'Done': 'Klaar',
    // Directions
    'Cancel route': 'Route annuleren',
    'Finish route': 'Route voltooien ',
    // Share location link
    'Share': 'Deel',
    'Copy link': 'Link kopiëren',
    'QR Code': 'QR code',
    // Opening Hours
    'Open': 'Open',
    'Closed': 'Gesloten',
    'Expand opening hours': 'Openingsuren uitklappen',
    'Collapse opening hours': 'Openingsuren inklappen',
    // View Selector
    'Go to view': 'Toon locatie',
    'Close view selector': 'Sluiten weergavekiezer',
    // Language Selector
    'Select language': 'Selecteer taal',
    // Accessibility
    'Increase text size to 200%': 'Tekstgrootte verhogen naar 200%',
    'Decrease text size to 100%': 'Tekstgrootte verlagen naar 100%',
    // Map Controls
    'Zoom in': 'Inzoomen',
    'Zoom out': 'Uitzoomen',
    // Ask with AI - Usage Consent
    'Usage consent title': 'Ask with AI - Toestemming voor gebruik',
    'Usage consent message': 'Ask with AI helpt je plaatsen te vinden en te navigeren in deze locatie met behulp van Kunstmatige Intelligentie (AI). Hoewel we streven naar nauwkeurigheid, kan de AI soms fouten maken. Controleer belangrijke details voordat je op weg gaat.',
    'Usage consent accept': 'Ik begrijp het',
    'Usage consent decline': 'Weigeren',
    'AI disclaimer': 'Ask with AI kan fouten maken. Controleer belangrijke details voordat je op weg gaat.',
    // Location Consent
    'Location consent message': 'Om gepersonaliseerde routebeschrijvingen te bieden en je te helpen ontdekken wat er in de buurt is, wil Ask with AI toegang tot je locatie. De chat werkt nog steeds zonder je locatie te kennen, maar je zult dan een startpunt moeten opgeven.',
    'Location consent accept': 'Toestaan',
    'Location consent decline': 'Weigeren',
};

export default nl;
